import {
  NavigationPageItemDto,
  TableauChartDto,
  WidgetDto,
} from '@asset-metrix/portal-gateway-client-js';
import { FullscreenWidgetModal } from '@asset-metrix/portal-ui';
import { useDisclosure } from '@mantine/hooks';

import { useFullscreenInstanceIds } from '../../hooks/useFullscreenInstanceIds';
import { InfoIconModal } from '../infoicon/InfoIconModal';

import { TableauChartContent } from './TableauChartContent';

export type TableauChartProps = Pick<
  WidgetDto,
  'allowOpenInFullscreen' | 'collapsible' | 'title' | 'infoIcon' | 'id'
> & {
  entity: TableauChartDto;
  instanceId: string;
  pageId: NavigationPageItemDto['pageId'];
};

export const TableauChart = ({
  allowOpenInFullscreen,
  collapsible = false,
  entity,
  id: widgetId,
  infoIcon,
  instanceId,
  title,
  pageId,
}: TableauChartProps) => {
  const {
    fullscreenInstanceStateId,
    cloneFullscreenInstanceState,
    customPageFilterStoreId,
  } = useFullscreenInstanceIds({
    pageFilterInstanceId: instanceId,
    widgetFilterInstanceId: widgetId,
  });

  const [infoIconOpened, { close: closeInfoModal, open: openInfoModal }] =
    useDisclosure();
  const [fullscreenOpened, { close: closeFullscreen, open: openFullscreen }] =
    useDisclosure(false, {
      onOpen: cloneFullscreenInstanceState,
    });

  return (
    <>
      <TableauChartContent
        collapsible={collapsible}
        entity={entity}
        openFullscreen={allowOpenInFullscreen ? openFullscreen : undefined}
        enableScrollElementToTop
        infoIcon={infoIcon}
        openInfoModal={openInfoModal}
        pageFilterInstanceId={instanceId}
        pageId={pageId}
        title={title}
        widgetId={widgetId}
      />

      {allowOpenInFullscreen && (
        <FullscreenWidgetModal
          opened={fullscreenOpened}
          onClose={closeFullscreen}
        >
          <TableauChartContent
            closeFullscreen={closeFullscreen}
            collapsible={collapsible}
            customPageFilterStoreId={customPageFilterStoreId}
            entity={entity}
            infoIcon={infoIcon}
            isFullscreen
            openInfoModal={openInfoModal}
            pageFilterInstanceId={fullscreenInstanceStateId}
            pageId={pageId}
            showPageFilter={true}
            title={title}
            widgetId={widgetId}
          />
        </FullscreenWidgetModal>
      )}
      {infoIcon && (
        <InfoIconModal
          onClose={closeInfoModal}
          opened={infoIconOpened}
          headline={infoIcon?.headline}
          text={infoIcon?.text}
        />
      )}
    </>
  );
};
